import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { TaskTypeControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting: GridSortItem[];
  searchString?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

export type OptionData = {
  uuid: string;
  title: string;
};

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useTaskTypeList = ({
  pagination,
  gridSorting,
  searchString,
  xTENANTID,
  enabled,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "task-type-list",
      pageIndex,
      pagination.pageSize,
      gridSorting,
      sortDirect,
      searchString,
      xTENANTID,
    ],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled ?? true,
    queryFn: async () =>
      await new TaskTypeControllerApi(getConfigObject())
        .getAllTaskType(
          pageIndex, //page
          pagination.pageSize, //size
          sortBy,
          sortDirect, // sortDirection
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
